export enum RequestTypes {
  CustomerService = 36,
  EquipmentRepair = 220
}
